export const payvayGuideSteps = [
  {
    title: 'Open your PayVay App',
    description: 'Launch your PayVay App',
  },
  {
    title: 'Check notifications',
    description:
      'You will receive a payment request notification. Tap on it to view details.',
  },
  {
    title: 'Review payment details',
    description:
      'Verify the merchant name (Gadgets Zone) and amount are correct.',
  },
  {
    title: 'Approve the payment',
    description:
      'Tap "Approve" or "Accept" and authenticate with your PIN/biometrics. This page will update automatically.',
  },
]
